import { threekitApi } from "../imports";

export default class ThreekitImage {
  constructor({ height, width, objAsset }) {
    this.height = height;
    this.width = width;
    this.objAsset = objAsset;
  }

  get imageassetId() {
    return this.objAsset.imageassetId;
  }

  static async create(file) {
    const imageSize = await this.imageSize(file);
    const { height, width } = imageSize;
    const jobId = await threekitApi.uploadFileToThreeKit(file);
    const objAsset = await this.checkFileUploadStatus(jobId);
    return new ThreekitImage(height, width, objAsset);
  }

  static async checkFileUploadStatus(jobId) {
    let objAsset = await threekitApi.getAssetIDfromJob(jobId);
    while (objAsset?.job_status != "stopped") {
      await this.sleep(500);
      objAsset = await threekitApi.getAssetIDfromJob(jobId);
    }
    return objAsset;
  }

  static async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static async imageSize(file) {
    let url = URL.createObjectURL(file);
    let img = new Image();
    const promise = new Promise((resolve, reject) => {
      img.onload = () => {
        // Natural size is the actual image size regardless of rendering.
        // The 'normal' `width`/`height` are for the **rendered** size.
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        // Resolve promise with the width and height
        resolve({ width, height });
      };

      // Reject promise on error
      img.onerror = reject;
    });

    // Setting the source makes it start downloading and eventually call `onload`
    img.src = url;

    return promise;
  }
}
